export enum RevisionContentTypes {
    content = 0,
    summary = 1,
    commentary = 2,
    interpretation = 3,
    osha = 4
}